<my-content placeholder="navigation">
    <br>
    <br>
    <br>
        
    <!-- Notice Exposure Amount Report--->
    <div class="panel-group" style="margin-top: 46px;" id="HideNoticeExposure" ng-app="myApp">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title">
                    <a data-toggle="collapse" href="#collapseNoticeExpAmt">Notice Exposure Amount Report {{NeaHeading}} As On Date = {{date}}</a>
                </h4>
            </div>
            <div id="collapseNoticeExpAmt" class="collapse in ">
                <div class="panel-body">
                    <div id="NoticeExpAmtReport" class="row" id="HideNoticeExposurePrintRow">

                        <div class="col-sm-4"><label class="radio-inline"><input type="radio" Name="NeaChartType" (click)="OnSelectNeaChart('Pie')" value="1" checked >Pie Chart</label>
                            <label class="radio-inline"><input type="radio" Name="NeaChartType" (click)="OnSelectNeaChart('Bar')"  value="0"  >Bar Chart</label>
                        </div>
                        <div class="col-sm-6"><label class="radio-inline"><input type="radio" Name="NeaSent" (click)="NeaIsSent('1')" value="1" checked >Sent</label>
                            <label class="radio-inline"><input type="radio" Name="NeaSent" (click)="NeaIsSent('0')"  value="0"  >Received</label>
                        </div>
                        <div class="col-sm-1 btn btn-light"><a Title="Print" (click)="PrintDiv('HideNoticeExposure','HideNoticeExposurePrintRow')"><i class="material-icons">
                           print
                             </i><span id="MaterialText">Print</span></a>
                        </div>
                    </div>
                    <div class="row"> <br><br></div>
                    <div class="row">
                        <div class="col-sm col-xs">
                            <table width="100%" class="LMtable">
                                <tr>
                                    <th class="center">Module</th>
                                    <th class="center">Count</th>
                                </tr>
                                <tr *ngFor="let mDtl of NoticeExposureData; let i=index">
                                    <td> {{mDtl.Title}} </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Value}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Value}} </a> </td>
                                   
                                </tr>
                            </table>
                        </div>
                        <div class="col-sm col-xs" [hidden]="NeaHidePie">
                            <canvas
                              baseChart
                              [data]="NoticeExpAmtpieChartData"
                              [labels]="NoticeExpAmtpieChartLabels"
                              [type]="pieChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>

                        <div class="col-sm col-xs" [hidden]="NeaHideBar">
                            <canvas
                              baseChart
                              [datasets]="NoticeExpAmtbarChartData"
                              [labels]="NoticeExpAmtbarChartLabels"
                              [options]="barChartOptions"
                              [legend]="barChartLegend"
                              [type]="barChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end Notice Exposure Amount Report--->

    <!-- Notice stages Report--->
    <div class="panel-group" id="HideNoticeStages">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title">
                    <a data-toggle="collapse" href="#collapseNoticeStages">Notice Stages Report {{NsHeading}} As On Date = {{date}}</a>
                </h4>
            </div>
            <div id="collapseNoticeStages" class="collapse in">
                <div class="panel-body">
                    <div id="NoticeStagesReport" class="row" id="HideNoticeStagesPrintRow">

                        <div class="col-sm-3"><label class="radio-inline"><input type="radio" Name="NsChartType" (click)="OnSelectNsChart('Pie')" value="1" >Pie Chart</label>
                            <label class="radio-inline"><input type="radio" Name="NsChartType" (click)="OnSelectNsChart('Bar')"  value="0" checked >Bar Chart</label>
                        </div>
                        <div class="col-sm-3"><label class="radio-inline"><input type="radio" Name="NsSentt" (click)="NsIsSent('1')" value="1" checked >Sent</label>
                            <label class="radio-inline"><input type="radio" Name="NsSentt" (click)="NsIsSent('0')"  value="0"  >Received</label>
                        </div>
                        <div class="col-sm-4"><label class="radio-inline"><input type="radio" Name="NsAmountt" (click)="NsIsAmount('1')" value="1"  >Amount</label>
                            <label class="radio-inline"><input type="radio" Name="NsAmountt" (click)="NsIsAmount('0')"  value="0" checked >Count</label>
                        </div>
                        <div class="col-sm-1 btn btn-light"><a Title="Print" (click)="PrintDiv('HideNoticeStages','HideNoticeStagesPrintRow')"><i class="material-icons">
                       print
                         </i><span id="MaterialText">Print</span></a>
                        </div>
                    </div>
                    <div class="row"> <br><br></div>
                    <div class="row">
                        <div class="col-sm col-xs">
                            <table width="100%" class="LMtable">
                                <tr>
                                    <th class="center">Module</th>
                                    <th class="center">Count</th>
                                    <th class="center">Amount</th>
                                </tr>
                                <tr *ngFor="let mDtl of NoticeStagesData; let i=index">
                                    <td> {{mDtl.Title}} </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Value}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Value}} </a> </td>

                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Amount}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Amount}} </a> </td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-sm col-xs" [hidden]="NsHidePie">
                            <canvas
                              baseChart
                              [data]="NoticeStagespieChartData"
                              [labels]="NoticeStagespieChartLabels"
                              [type]="pieChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>
                        <div class="col-sm col-xs" [hidden]="NsHideBar">
                            <canvas
                              baseChart
                              [datasets]="NoticeStagesbarChartData"
                              [labels]="NoticeStagesbarChartLabels"
                              [options]="barChartOptions"
                              [legend]="barChartLegend"
                              [type]="barChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end Notice stages Report--->

    <!-- Notice Seriousness Report--->
    <div class="panel-group" id="HideNoticeSeriousness">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title">
                    <a data-toggle="collapse" href="#collapseNoticeSeriousness">Notice Seriousness Report {{NsnHeading}} As On Date = {{date}}</a>
                </h4>
            </div>
            <div id="collapseNoticeSeriousness" class="collapse in">
                <div class="panel-body">
                    <div id="NoticeSeriousnessReport" class="row" id="HideNoticeSeriousnessPrintRow">

                        <div class="col-sm-3"><label class="radio-inline"><input type="radio" Name="NsnChartType" (click)="OnSelectNsnChart('Pie')" value="1" >Pie Chart</label>
                            <label class="radio-inline"><input type="radio" Name="NsnChartType" (click)="OnSelectNsnChart('Bar')"  value="0" checked >Bar Chart</label>
                        </div>
                        <div class="col-sm-3"><label class="radio-inline"><input type="radio" Name="NsnSentt" (click)="NsnIsSent('1')" value="1" checked >Sent</label>
                            <label class="radio-inline"><input type="radio" Name="NsnSentt" (click)="NsnIsSent('0')"  value="0"  >Received</label>
                        </div>
                        <div class="col-sm-4"><label class="radio-inline"><input type="radio" Name="NsnAmountt" (click)="NsnIsAmount('1')" value="1"  >Amount</label>
                            <label class="radio-inline"><input type="radio" Name="NsnAmountt" (click)="NsnIsAmount('0')"  value="0" checked >Count</label>
                        </div>
                        <div class="col-sm-1 btn btn-light"><a Title="Print" (click)="PrintDiv('HideNoticeSeriousness','HideNoticeSeriousnessPrintRow')"><i class="material-icons">
                       print
                         </i><span id="MaterialText">Print</span></a>
                        </div>
                    </div>
                    <div class="row"> <br><br></div>
                    <div class="row">
                        <div class="col-sm col-xs">
                            <table width="100%" class="LMtable">
                                <tr>
                                    <th class="center">Module</th>
                                    <th class="center">Count</th>
                                    <th class="center">Amount</th>
                                </tr>
                                <tr *ngFor="let mDtl of NoticeSeriousnessData; let i=index">
                                    <td> {{mDtl.Title}} </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Value}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Value}} </a> </td>

                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Amount}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Amount}} </a> </td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-sm col-xs" [hidden]="NsnHidePie">
                            <canvas
                              baseChart
                              [data]="NoticeSeriousnesspieChartData"
                              [labels]="NoticeSeriousnesspieChartLabels"
                              [type]="pieChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>
                        <div class="col-sm col-xs" [hidden]="NsnHideBar">
                            <canvas
                              baseChart
                              [datasets]="NoticeSeriousnessbarChartData"
                              [labels]="NoticeSeriousnessbarChartLabels"
                              [options]="barChartOptions"
                              [legend]="barChartLegend"
                              [type]="barChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end Notice Seriousness Report--->

    <!-- Case Exposure Amount Report--->
    <div class="panel-group" id="HideCaseExposure">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title">
                    <a data-toggle="collapse" href="#collapseCaseExpAmt">Case Exposure Amount Report {{CeaHeading}} As On Date = {{date}}</a>
                </h4>
            </div>
            <div id="collapseCaseExpAmt" class="collapse in">
                <div class="panel-body">
                    <div id="CaseExpAmtReport" class="row" id="HideCaseExposurePrintRow">

                        <div class="col-sm-4"><label class="radio-inline"><input type="radio" Name="CeaChartType" (click)="OnSelectCeaChart('Pie')" value="1" checked >Pie Chart</label>
                            <label class="radio-inline"><input type="radio" Name="CeaChartType" (click)="OnSelectCeaChart('Bar')"  value="0"  >Bar Chart</label>
                        </div>
                        <div class="col-sm-6"><label class="radio-inline"><input type="radio" Name="CeaSent" (click)="CeaIsSent('1')" value="1" checked >Filed By Us</label>
                            <label class="radio-inline"><input type="radio" Name="CeaSent" (click)="CeaIsSent('0')"  value="0"  >Against Us </label>
                        </div>
                        <div class="col-sm-1 btn btn-light"><a Title="Print" (click)="PrintDiv('HideCaseExposure','HideCaseExposurePrintRow')"><i class="material-icons">
                               print
                                 </i><span id="MaterialText">Print</span></a>
                        </div>
                    </div>
                    <div class="row"> <br><br></div>
                    <div class="row">
                        <div class="col-sm col-xs">

                            <table width="100%" class="LMtable">
                                <tr>
                                    <th class="center">Module</th>
                                    <th class="center">Count</th>
                                </tr>
                                <tr *ngFor="let mDtl of CaseExposureData; let i=index">
                                    <td> {{mDtl.Title}} </td>
                                    
                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Value}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Value}} </a> </td>
                                </tr>
                            </table>
                        </div>

                        <div class="col-sm col-xs" [hidden]="CeaHidePie">
                            <canvas
                              baseChart
                              [data]="CaseExpAmtpieChartData"
                              [labels]="CaseExpAmtpieChartLabels"
                              [type]="pieChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>

                        <div class="col-sm col-xs" [hidden]="CeaHideBar">
                            <canvas
                              baseChart
                              [datasets]="CaseExpAmtbarChartData"
                              [labels]="CaseExpAmtbarChartLabels"
                              [options]="barChartOptions"
                              [legend]="barChartLegend"
                              [type]="barChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end Case Exposure Amount Report--->

    <!-- Case stages Report--->
    <div class="panel-group" id="HideCaseStages">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title">
                    <a data-toggle="collapse" href="#collapseCaseStages">Case Stages Report {{CsHeading}} As On Date = {{date}}</a>
                </h4>
            </div>
            <div id="collapseCaseStages" class="collapse in">
                <div class="panel-body">
                    <div id="CaseStagesReport" class="row" id="HideCaseStagesPrintRow">

                        <div class="col-sm-3"><label class="radio-inline"><input type="radio" Name="CsChartType" (click)="OnSelectCsChart('Pie')" value="1" >Pie Chart</label>
                            <label class="radio-inline"><input type="radio" Name="CsChartType" (click)="OnSelectCsChart('Bar')"  value="0" checked >Bar Chart</label>
                        </div>
                        <div class="col-sm-3"><label class="radio-inline"><input type="radio" Name="CsSentt" (click)="CsIsSent('1')" value="1" checked >Filed By Us</label>
                            <label class="radio-inline"><input type="radio" Name="CsSentt" (click)="CsIsSent('0')"  value="0"  >Against Us</label>
                        </div>
                        <div class="col-sm-4"><label class="radio-inline"><input type="radio" Name="CsAmountt" (click)="CsIsAmount('1')" value="1"  >Amount</label>
                            <label class="radio-inline"><input type="radio" Name="CsAmountt" (click)="CsIsAmount('0')"  value="0" checked >Count</label>
                        </div>
                        <div class="col-sm-1 btn btn-light"><a Title="Print" (click)="PrintDiv('HideCaseStages','HideCaseStagesPrintRow')"><i class="material-icons">
                   print
                     </i><span id="MaterialText">Print</span></a>
                        </div>
                    </div>
                    <div class="row"> <br><br></div>
                    <div class="row">
                        <div class="col-sm col-xs">
                            <table width="100%" class="LMtable">
                                <tr>
                                    <th class="center">Module</th>
                                    <th class="center">Count</th>
                                    <th class="center">Amount</th>
                                </tr>
                                <tr *ngFor="let mDtl of CaseStagesData; let i=index">
                                    <td> {{mDtl.Title}} </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Value}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Value}} </a> </td>

                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Amount}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Amount}} </a> </td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-sm col-xs" [hidden]="CsHidePie">
                            <canvas
                              baseChart
                              [data]="CaseStagespieChartData"
                              [labels]="CaseStagespieChartLabels"
                              [type]="pieChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>
                        <div class="col-sm col-xs" [hidden]="CsHideBar">
                            <canvas
                              baseChart
                              [datasets]="CaseStagesbarChartData"
                              [labels]="CaseStagesbarChartLabels"
                              [options]="barChartOptions"
                              [legend]="barChartLegend"
                              [type]="barChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end Case stages Report--->

<!-- Case Seriousness Report--->
<div class="panel-group" id="HideCaseSeriousness">
    <div class="panel panel-default">
        <div class="panel-heading">
            <h4 class="panel-title">
                <a data-toggle="collapse" href="#collapseCaseSeriousness">Case Seriousness Report {{CsnHeading}} As On Date = {{date}}</a>
            </h4>
        </div>
        <div id="collapseCaseSeriousness" class="collapse in">
            <div class="panel-body">
                <div id="CaseSeriousnessReport" class="row" id="HideCaseSeriousnessPrintRow">

                    <div class="col-sm-3"><label class="radio-inline"><input type="radio" Name="CsnChartType" (click)="OnSelectCsnChart('Pie')" value="1" >Pie Chart</label>
                        <label class="radio-inline"><input type="radio" Name="CsnChartType" (click)="OnSelectCsnChart('Bar')"  value="0" checked >Bar Chart</label>
                    </div>
                    <div class="col-sm-3"><label class="radio-inline"><input type="radio" Name="CsnSentt" (click)="CsnIsSent('1')" value="1" checked >Filed By Us</label>
                        <label class="radio-inline"><input type="radio" Name="CsnSentt" (click)="CsnIsSent('0')"  value="0"  >Against Us</label>
                    </div>
                    <div class="col-sm-4"><label class="radio-inline"><input type="radio" Name="CsnAmountt" (click)="CsnIsAmount('1')" value="1"  >Amount</label>
                        <label class="radio-inline"><input type="radio" Name="CsnAmountt" (click)="CsnIsAmount('0')"  value="0" checked >Count</label>
                    </div>
                    <div class="col-sm-1 btn btn-light"><a Title="Print" (click)="PrintDiv('HideCaseSeriousness','HideCaseSeriousnessPrintRow')"><i class="material-icons">
               print
                 </i><span id="MaterialText">Print</span></a>
                    </div>
                </div>
                <div class="row"> <br><br></div>
                <div class="row">
                    <div class="col-sm col-xs">
                        <table width="100%" class="LMtable">
                            <tr>
                                <th class="center">Module</th>
                                <th class="center">Count</th>
                                <th class="center">Amount</th>
                            </tr>
                            <tr *ngFor="let mDtl of CaseSeriousnessData; let i=index">
                                <td> {{mDtl.Title}} </td>
                                <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Value}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Value}} </a> </td>

                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Amount}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Amount}} </a> </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-sm col-xs" [hidden]="CsnHidePie">
                        <canvas
                          baseChart
                          [data]="CaseSeriousnesspieChartData"
                          [labels]="CaseSeriousnesspieChartLabels"
                          [type]="pieChartType"
                          (chartHover)="chartHovered($event)"
                          (chartClick)="chartClicked($event)">
                        </canvas>
                    </div>
                    <div class="col-sm col-xs" [hidden]="CsnHideBar">
                        <canvas
                          baseChart
                          [datasets]="CaseSeriousnessbarChartData"
                          [labels]="CaseSeriousnessbarChartLabels"
                          [options]="barChartOptions"
                          [legend]="barChartLegend"
                          [type]="barChartType"
                          (chartHover)="chartHovered($event)"
                          (chartClick)="chartClicked($event)">
                        </canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end Case Seriousness Report--->


    <!-- Dashboard Pending Report--->
    <div class="panel-group" id="HidePending">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title">
                    <a data-toggle="collapse" href="#collapsePending">Pending Work Detail As On Date = {{date}} </a>
                </h4>
            </div>
            <div id="collapsePending" class="collapse in">
                <div class="panel-body">
                    <div id="pendingReport" id="HidePendingPrintRow">
                        <div style="float:left;">
                            <label class="radio-inline"><input type="radio" Name="PendingChartType" (click)="OnSelectPendingChart('Pie')" value="1" checked >Pie Chart</label>
                            <label class="radio-inline"><input type="radio" Name="PendingChartType" (click)="OnSelectPendingChart('Bar')"  value="0"  >Bar Chart</label>
                        </div>
                        <div style="float:right;" id="HideSubMenu">
                            <div class="col-sm-12 btn btn-light"><a Title="Print" (click)="PrintDiv('HidePending','HidePendingPrintRow')"><i class="material-icons">
                           print
                             </i><span id="MaterialText">Print</span></a>
                            </div>
                        </div>
                    </div>
                    <div class="row"> <br><br></div>
                    <div class="row">
                        <div class="col-sm col-xs">

                            <table width="100%" class="LMtable">
                                <tr>
                                    <th class="center">Module</th>
                                    <th class="center">Count</th>
                                </tr>
                                <tr *ngFor="let mDtl of PendingData; let i=index">
                                    <td> {{mDtl.Title}} </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Value}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Value}} </a> </td>
                                </tr>
                            </table>
                        </div>

                        <div class="col-sm col-xs" [hidden]="HidePie">
                            <canvas
                              baseChart
                              [data]="PendingpieChartData"
                              [labels]="PendingpieChartLabels"
                              [type]="pieChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>

                        <div class="col-sm col-xs" [hidden]="HideBar">
                            <canvas
                              baseChart
                              [datasets]="PendingbarChartData"
                              [labels]="PendingbarChartLabels"
                              [options]="barChartOptions"
                              [legend]="barChartLegend"
                              [type]="barChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end Dashboard Pending Report--->

    <!-- Upcoming Hearing Report--->
    <div class="panel-group" id="HideHearing">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title">
                    <a data-toggle="collapse" href="#collapseUpcomingHearing">Upcoming Hearing </a>
                </h4>
            </div>
            <div id="collapseUpcomingHearing" class="collapse in">
                <div class="panel-body">
                    <div id="UpcomingReport" id="HideHearingPrintRow">
                        <div style="float:left;">
                            <label class="radio-inline"><input type="radio" Name="UpcomingChartType" (click)="OnSelectUpcomingChart('Pie')" value="1" >Pie Chart</label>
                            <label class="radio-inline"><input type="radio" Name="UpcomingChartType" (click)="OnSelectUpcomingChart('Bar')"  value="0" checked >Bar Chart</label>
                        </div>
                        <div style="float:right;" id="HideSubMenu">
                            <div class="col-sm-12 btn btn-light"><a Title="Print" (click)="PrintDiv('HideHearing','HideHearingPrintRow')"><i class="material-icons">
                        print
                            </i><span id="MaterialText">Print</span></a>
                            </div>
                        </div>
                    </div>
                    <div class="row"> <br><br></div>
                    <div class="row">
                        <div class="col-sm col-xs">

                            <table width="100%" class="LMtable">
                                <tr>
                                    <th class="center">Module</th>
                                    <th class="center">Count</th>
                                </tr>
                                <tr *ngFor="let mDtl of UpcomingHearingData; let i=index">
                                    <td> {{mDtl.Title}} </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value == '0'"> {{mDtl.Value}}  </td>
                                    <td style="text-align: right;" *ngIf="mDtl.Value != '0'"> <a href={{mDtl.Link}} target="_blank"> {{mDtl.Value}} </a> </td>
                                </tr>
                            </table>
                        </div>

                        <div class="col-sm col-xs" [hidden]="UpcomingHidePie">
                            <canvas
                              baseChart
                              [data]="UpcomingpieChartData"
                              [labels]="UpcomingpieChartLabels"
                              [type]="pieChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>

                        <div class="col-sm col-xs" [hidden]="UpcomingHideBar">
                            <canvas
                              baseChart
                              [datasets]="UpcomingbarChartData"
                              [labels]="UpcomingbarChartLabels"
                              [options]="barChartOptions"
                              [legend]="barChartLegend"
                              [type]="barChartType"
                              (chartHover)="chartHovered($event)"
                              (chartClick)="chartClicked($event)">
                            </canvas>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end Upcoming Hearing Report--->


    <div>&nbsp;<br></div>
</my-content>
<my-content placeholder="main">


</my-content>